// ** Type import
import { HorizontalNavItemsType } from 'src/@core/layouts/types'
import { userStorage } from 'src/utils/localStorage'

const navigationAdmin = (): HorizontalNavItemsType => {
    if (userStorage.isAdmin()) {
        return [

        ]
    } else {
        return []
    }
}
const navigation = (): HorizontalNavItemsType => [
    {
        title: 'Entregas',
        path: '/home',
        icon: 'iconamoon:delivery-fast-thin',
    },
    {
        title: 'Volquetes',
        path: '/volquetes',
        icon: 'ph:truck-thin',
    },
        {
        title: 'Pedidos',
        path: '/pedidos',
        icon: 'ph:truck-thin',
    },

    ...navigationAdmin()
]

export default navigation
